import { useGetSettingsQuery } from 'core/api/settings/queries';
import ErrorsList from 'ui/components/errors-list/ErrorsList';
import LinesSkeleton from 'ui/components/skeletons/lines-skeleton/LinesSkeleton';

import { Box } from '@mui/material';

import PaymentusSettings from './components/paymentus-info-settings/PaymentusSettings';

export default function GeneralSettings() {
  const { isLoading, isError, data, error } = useGetSettingsQuery();

  return (
    <>
      {!isLoading && data && (
        <>
          <PaymentusSettings data={data.paymentusSettings} />
        </>
      )}

      {isLoading && !isError && (
        <Box mb={4}>
          <LinesSkeleton elements={4} isWithButtons={false} lineHeight={35} />
        </Box>
      )}

      {isError && error && <ErrorsList title="Unexpected loading error" errors={error} />}
    </>
  );
}
